import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { track } from "@/lib/analytics";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const [num, setNum] = useState("+919872581418");
  useEffect(() => {
    fetch(`${API}/settings`)
      .then((r) => r.json())
      .then((d) => d.whatsapp_number && setNum(d.whatsapp_number))
      .catch(() => {});
  }, []);
  const clean = (num || "").replace(/[^0-9]/g, "");
  const href = `https://wa.me/${clean}?text=${encodeURIComponent(
    "Hi Atlas — I'd like help sourcing a product."
  )}`;
  return (
    <a
      className="wa"
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-button"
      onClick={() => { track("cta_click", { cta: "whatsapp" }); track("whatsapp_click", { placement: "floating" }); }}
    >
      <MessageCircle size={14} style={{ display: "inline", verticalAlign: "middle", marginRight: 6 }} />WhatsApp
    </a>
  );
}
